var map = {
	"./fhrs_0_en-gb.svg": [
		8944,
		8944
	],
	"./fhrs_1_en-gb.svg": [
		7157,
		7157
	],
	"./fhrs_2_en-gb.svg": [
		7234,
		7234
	],
	"./fhrs_3_en-gb.svg": [
		1431,
		1431
	],
	"./fhrs_4_en-gb.svg": [
		9148,
		9148
	],
	"./fhrs_5_en-gb.svg": [
		8465,
		8465
	],
	"./fhrs_awaitinginspection_en-gb.svg": [
		6476,
		6476
	],
	"./fhrs_awaitingpublication_en-gb.svg": [
		9623,
		2004
	],
	"./fhrs_exempt_en-gb.svg": [
		765,
		765
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2778;
module.exports = webpackAsyncContext;